import React from 'react';
import { getWebAbsPath } from '../../../../util/path';
import styles from '../../../NewPatient/Questionnaire/NewPatientQuestionnaire.module.css';

export const ReadOnlyTeeth = ({ selectedTooth = [], side = '', teeth, isInSummary = false }) => {
    const commonStyle = {
        'margin-top': '10px',
        position: 'relative',
        backgroundRepeat: 'no-repeat',
    };

    const containerWidth = isInSummary ? 800 : 1175;

    const style = isInSummary
        ? {
              ...commonStyle,
              width: 800,
              height: 200,
              backgroundImage: `url("${getWebAbsPath('/img/prescriptionNotes/smaller_teeth_number_CS.ai.png')}")`,
          }
        : {
              ...commonStyle,
              width: 1175,
              height: 200,
              backgroundImage: `url("${getWebAbsPath(side == 'Top' ? '/img/prescriptionNotes/top_teeth_number_CS6.ai.png' : '/img/prescriptionNotes/bottom_teeth_number_CS6.ai.png')}")`,
          };
    return (
        <div className={isInSummary ? styles.toothImages : ''} style={{ width: containerWidth }} tabIndex="0">
            <div
                // style={{
                //   width: 1175,
                //   height: 300,
                //   'margin-top': "10px",
                //   position: "relative",
                //   backgroundRepeat: "no-repeat",
                //   backgroundImage: `url("${getWebAbsPath(side == "Top" ? '/img/prescriptionNotes/top_teeth_number_CS6.ai.png': '/img/prescriptionNotes/bottom_teeth_number_CS6.ai.png')}")`,
                //   // backgroundColor: props.attachments.value === "includedExcludedAttachments" && props.attachments.doNotPlace.length === 0 && props.prescriptionError && props.prescriptionErrorQuestion === 1 ? '#faff78' : null
                //   // cursor: disabled ? 'not-allowed' : 'default'
                // }}
                style={style}
            >
                {selectedTooth.map((toothValue) => {
                    for (let [_, objValue] of Object.entries(teeth)) {
                        for (let { value, positionX, positionY } of objValue.values) {
                            if (value === toothValue) {
                                return (
                                    <img
                                        key={value}
                                        src={getWebAbsPath('/img/prescriptionNotes/checkSuccess.png')}
                                        alt="checked"
                                        style={{
                                            position: 'absolute',
                                            top: positionY - 10,
                                            left: positionX - 12,
                                            userSelect: 'none',
                                            height: 'auto',
                                            width: 'auto',
                                        }}
                                    />
                                );
                            }
                        }
                    }
                })}
            </div>
        </div>
    );
};
